// The orders of Find a tutor, in one list (#1096): the sort menu, the line under it that says what the selected
// order means (TutorSortHelp), and the "How we order tutors" page all read it, so a fifth order can't ship
// without a definition (the test pins that every option has one).
//
// `value` is the stable English token (it drives the sortBy state and the sort URL parameter); only the labels
// are localized. `helpKey` is the one-line meaning shown under the menu.
export const SORT_OPTIONS = [
  { value: "Newest", labelKey: "findTutors.sort.newest", helpKey: "howWeOrderTutors.sortHelp.newest" },
  { value: "Top rated", labelKey: "findTutors.sort.topRated", helpKey: "howWeOrderTutors.sortHelp.topRated" },
  { value: "Price: Low to High", labelKey: "findTutors.sort.priceLowToHigh", helpKey: "howWeOrderTutors.sortHelp.priceLowToHigh" },
  { value: "Price: High to Low", labelKey: "findTutors.sort.priceHighToLow", helpKey: "howWeOrderTutors.sortHelp.priceHighToLow" },
] as const;

export const HOW_WE_ORDER_PATH = "/how-we-order-tutors";
